import * as React from 'react'; // https://github.com/parcel-bundler/parcel/issues/1199
import { LoadingSpinnerComponent as Spinner } from '../LoadingSpinner/LoadingSpinnerComponent';

const LoadingScreenComponent = () => (
    <div className="sid-loading-screen">
        <Spinner />
    </div>
);

export { LoadingScreenComponent };
